/* import __COLOCATED_TEMPLATE__ from './page-title.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './page-title.module.scss';

@classic
@classNames('page-title', styles.component)
export default class SitePageTitle extends Component {}
